import { DefaultTheme } from 'styled-components';

import { colors } from '../colors';
import { Theme } from '../types';

const theme1: DefaultTheme = {
  name: Theme.theme1,

  // Text
  fontFamily: `Quicksand, san-serif`,
  fontColor: colors.ash,
  fontWeight: 600,
  fontSize: '14px',
  fontLineHeight: '1.5',
  lineHeight: 'normal',
  errorColor: colors.error,
  iconColor: colors.primary,

  // Button
  buttonFontWeight: 600,
  buttonFocusShadow: `0 0 3px ${colors.primaryHover}`,
  buttonPrimaryTextColor: colors.white,
  buttonPrimaryColor: colors.primary,
  buttonPrimaryHoverTextColor: colors.white,
  buttonPrimaryDisabledTextColor: colors.white,
  buttonPrimaryHoverColor: colors.primaryHover,
  buttonPrimaryDisabledColor: colors.primaryDisabled,
  buttonSecondaryBorderColor: colors.primary,
  buttonSecondaryColor: colors.primary,
  buttonSecondaryBackgroundColor: colors.white,
  buttonSecondaryHoverColor: colors.primaryHover,
  buttonSecondaryHoverBorderColor: colors.primaryHover,
  buttonSecondaryDisabledColor: colors.primaryDisabled,

  // Checkbox
  checkboxColor: colors.charcoal,
  checkboxFontWeight: 600,
  checkboxBorderColor: colors.smoke,
  checkboxBorderActiveColor: colors.primary,
  checkboxBackgroundColor: colors.white,
  checkboxBackgroundActiveColor: colors.primary,
  checkboxShadow: colors.primaryHover,
  checkboxHover: colors.primaryHover,

  // DatePicker
  datePickerShowOnlyBottomBorder: false,
  datePickerColor: colors.ash,
  datePickerBorderColor: colors.smoke,
  datePickerPlaceholderColor: colors.smoke,
  datePickerFocusedBorderColor: colors.primary,
  datePickerDisabledColor: colors.smoke,
  datePickerIconDisabledColor: colors.primaryDisabled,
  datePickerActiveColor: colors.primary,
  datePickerHoverActiveColor: colors.primaryHover,
  datePickerHoverShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  datePickerIconColor: colors.primary,
  datePickerPadding: '7px 10px 5px',
  datePickerCalendarIconPadding: '6px 10px',
  datePickerBackgroundColor: colors.white,
  datePickerInputHeight: '34px',

  // Dropdown
  dropdownIconColor: colors.primary,

  // Footer
  footerTextColor: colors.primaryOpacity,
  footerHeadingColor: colors.edgewater,
  footerCheckIconColor: colors.primary,
  footerSocialIconColor: colors.primaryOpacity,
  footerLineColor: colors.primaryOpacity,
  footerInputErrorColor: colors.error,
  footerIconColor: colors.ash,
  footerBackgroundDark: colors.primaryHover,
  footerBackgroundLight: colors.primaryHover,

  // Form
  formRowLabelColor: colors.charcoal,
  formRowLabelFontSize: '16px',
  formRowLabelPadding: '0',
  formRowGap: '20px',

  // Heading
  // sizes: 1, 2, 3, 4, 5, 6, 7
  headingSizes: ['70px', '50px', '36px', '30px', '24px', '20px', '16px'],
  headingLineHeight: ['1.1', '1.1', '1.1', '1.1', '1.1', '1.1', '1.1'],
  headingMobileSizes: ['50px', '36px', '30px', '24px', '20px', '18px', '14px'],
  headingOutline: '12px',
  headingOutlineLineHeight: '1.1',
  headingFontFamily: `Quicksand, san-serif`,
  headingFontWeight: '700',

  // Link
  linkColor: colors.primary,
  linkHoverColor: colors.primaryHover,
  linkDisabledColor: colors.primaryDisabled,

  // LinkButton
  linkButtonIconColor: colors.primary,
  linkButtonIconColorDisabled: colors.primaryDisabled,

  // Modal
  modalLineColor: colors.primary,

  // Nav
  navLinkColor: colors.primary,
  navLinkBackgroundColor: colors.primary,
  navSubMenuItemHoverBackgroundColor: colors.whiteIce,
  navMenuItemBackgroundColor: colors.whiteIce,
  navMobileSignInLinkColor: colors.primary,
  navUserIconBackgroundColor: colors.whiteIce,
  navUserIconColor: colors.primary,
  navMenuHamburgerColor: colors.primary,
  navBorderColor: colors.edgewater,

  // Navbar
  navbarColor: colors.charcoal,
  navbarColorHover: colors.gray,

  // PDF
  pdfControlsColor: colors.primary,
  pdfControlsDisabledColor: colors.primaryDisabled,
  pdfIconColor: colors.primary,
  pdfIconDisabledColor: colors.primaryDisabled,
  pdfControlsIconColor: colors.white,

  // Radio
  radioColor: colors.charcoal,
  radioBorderColor: colors.smoke,
  radioBorderActiveColor: colors.primary,
  radioBackgroundColor: colors.white,
  radioBackgroundActiveColor: colors.primary,
  radioShadow: colors.primaryHover,
  radioHover: colors.primaryHover,
  radioSize: 20,
  radioInputTopPosition: 0,

  // Select Input
  selectShowOnlyBottomBorder: false,
  selectShowIndicatorAnimation: false,
  selectColor: colors.ash,
  selectPlaceholderColor: colors.smoke,
  selectDisabledColor: colors.smoke,
  selectBorderColor: colors.charcoal,
  selectPrimaryBorderColor: colors.smoke,
  selectPrimaryHoverBorderColor: colors.smoke,
  selectPrimaryFocusedBorderColor: colors.primary,
  selectPrimaryDisabledBackgroundColor: colors.pearl,
  selectHoverShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  selectInputPadding: '0',
  selectInputBackgroundColor: colors.white,
  selectMenuShadow: 'none',
  selectMenuBorder: `1px solid ${colors.cloud}`,
  selectOptionPadding: '16px 10px',
  selectOptionActiveColor: colors.ash,
  selectDisabledBorderColor: colors.cloud,
  selectIndicatorIcon: 'caret-down',
  selectIndicatorIconSize: 20,
  selectIndicatorIconViewWidth: 20,
  selectIndicatorIconViewHeight: 20,
  selectIndicatorIconColor: colors.primary,
  selectInputHeight: '34px',

  // Tabs
  tabsActiveColor: colors.charcoal,
  tabsActiveBorderColor: colors.primary,

  // Text Input
  textInputShowOnlyBottomBorder: false,
  textInputColor: colors.ash,
  textInputFocusedColor: colors.charcoal,
  textInputBorderColor: colors.smoke,
  textInputFocusedBorderColor: colors.primary,
  textInputBackgroundColor: colors.white,
  textInputHoverShadow: '0 2px 4px 0 rgba(217, 217, 217, 0.5)',
  textInputPadding: '8px 10px',
  textInputPlaceholderColor: colors.smoke,
  textInputLabelColor: colors.darkblue,
  textInputNotePadding: '0',
  textInputNoteFontStyle: 'normal',
  textInputDisabledBorderColor: colors.cloud,
  textInputDisabledColor: colors.smoke,
  textInputShowAnimatedLabel: false,
  textInputIconColor: colors.primary,
  textInputHeight: '36px',

  // Textarea Input
  textAreaInputTextColor: colors.ash,
  textAreaInputBorderColor: colors.smoke,
  textAreaInputFocusTextColor: colors.charcoal,
  textAreaInputFocusBorderColor: colors.primary,
  textAreaInputDisabledTextColor: colors.smoke,
  textAreaInputDisabledBorderColor: colors.cloud,
  textAreaInputPlaceholderColor: colors.smoke,

  // Toggle
  toggleColor: colors.smoke,
  toggleActiveColor: colors.primary,

  // UserDropdown
  userDropdownColor: colors.primary,
  userDropdownColorHover: colors.primaryHover,

  inputErrorMessagePadding: '0',
};

export default theme1;
